import React, {useState} from 'react';
import {Formik, Field, FormikProps} from 'formik';
import {Image, Icon} from 'semantic-ui-react';
import _ from 'lodash';

import mappings from '@mappings';
import utils from '@utils';
import constants from '@constants';
import {Modal, Table, Pagination, Button, Form} from '@components';
import * as hooks from './hooks';
import * as handlers from './handlers';
import {Props} from './types';
import {makeColumns} from './Columns';

import './index.scss';

const Detail: React.FC<Props> = props => {
  const [isModal, setIsModal] = useState(false);
  const [isNotFoundModal, setIsNotFoundModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isPaging, setIsPaging] = useState(false);
  const [isResend, setIsResend] = useState(false);
  const [isFailedSendModal, setIsFailedSendModal] = useState(false);

  const initialValues = {
    userNames: [],
    userName: '',
    isSafe: false,
    isMinorInjury: false,
    isSeriousInjury: false,
    unAnswered: false,
    answered: false,
    isSuccess: false,
    isFailed: false,
    organization: '',
    organizations: [],
    position: '',
    positions: [],
  };

  hooks.useMount(props, props.actions, setLoading, setIsNotFoundModal);

  return (
    <div className="a__disaster-notices-detail">
      <div className="b__title">
        <Button.GoBack history={props.history} />
        災害通知詳細
      </div>
      <div className="b__main">
        <div className="b__subtitle">通知詳細</div>
        <div className="w__header-cards">
          <div className="w__card-column">
            <div className="b__card">
              <div className="w__card-header">
                <div className="b__image">
                  <Image src={constants.IMAGES.REPORT} />
                </div>
                <div className="b__title-text">送信日時</div>
              </div>
              <div className="b__divider" />
              <div className="b__card-content">
                {utils.date.format(
                  props.notifications.detail.sentDatetime,
                  'YYYY/MM/DD HH:mm:ss'
                )}
              </div>
            </div>
            <div className="b__card">
              <div className="w__card-header">
                <div className="b__image">
                  <Icon name="user outline" className="b__person" />
                </div>
                <div className="b__title-text">送信対象</div>
              </div>
              <div className="b__divider" />
              <div className="b__card-content">
                {props.notifications.detail.sentExecutionCount}&nbsp;件
              </div>
            </div>
            <div className="b__card">
              <div className="w__card-header">
                <div className="b__image sm">
                  <Image src={constants.IMAGES.NETWORK} />
                </div>
                <div className="b__title-text">送信方法</div>
              </div>
              <div className="b__divider" />
              <div className="b__card-content">
                {props.notifications.detail.isManual ? '手動送信' : '自動送信'}
              </div>
            </div>
          </div>

          <div className="w__card-column center">
            <div className="b__card">
              <div className="w__card-header">
                <div className="b__image">
                  <Image src={constants.IMAGES.POINT} />
                </div>
                <div className="b__title-text">地域</div>
              </div>
              <div className="b__divider" />
              <div className="b__card-content">
                {utils.mappings.getLabel(
                  mappings.prefectures,
                  props.notifications.detail.prefecture
                )}
              </div>
            </div>
            <div className="b__card">
              <div className="w__card-header">
                <div className="b__image">
                  <Image src={constants.IMAGES.LETTER} />
                </div>
                <div className="b__title-text">送信完了</div>
              </div>
              <div className="b__divider" />
              <div className="b__card-content">
                {props.notifications.detail.sentSuccessCount} 件
              </div>
            </div>
          </div>
          <div className="w__card-column">
            <div className="b__card">
              <div className="w__card-header">
                <div className="b__image">
                  <Image src={constants.IMAGES.CRACK} />
                </div>
                <div className="b__title-text">災害</div>
              </div>
              <div className="b__divider" />
              <div className="b__card-content">
                {utils.mappings.getLabel(
                  mappings.disasters,
                  props.notifications.detail.disasterType
                )}
                {props.notifications.detail.disasterType ===
                  mappings.disasters[0].value && (
                  <span>
                    {_.isNull(props.notifications.detail.intensity) ? null : (
                      <>
                        &nbsp; 震度
                        {utils.mappings.getLabel(
                          mappings.intensities,
                          props.notifications.detail.intensity
                        )}
                      </>
                    )}
                  </span>
                )}
              </div>
            </div>
            <div className="b__card">
              <div className="w__card-header">
                <div className="b__image">
                  <Image src={constants.IMAGES.CHECK_BOX} />
                </div>
                <div className="b__title-text">回答件数</div>
              </div>
              <div className="b__divider" />
              <div className="b__card-content">
                {props.notifications.detail.replyCount} 件
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="b__subtitle">通知メッセージ</div>
          <div className="b__message_card">
            <div className="b__card-content">
              {props.notifications.detail.message ? (
                <span>{props.notifications.detail.message}</span>
              ) : (
                'なし'
              )}
            </div>
          </div>
        </div>
        <div className="b__subtitle">通知対象ユーザー</div>
        <Formik initialValues={initialValues} onSubmit={() => {}}>
          {(formProps: FormikProps<any>) => {
            return (
              <div className="w__search-field">
                <div className="w__safety-search">
                  <div className="w__search">
                    <div className="w__row">
                      <div className="w__input-search name">
                        <Form.Label text="名前" />
                        <div className="w__input">
                          <Field
                            component={Form.Input}
                            name="userName"
                            color="white"
                            placeholder="名前"
                          />
                          <Button.Icon
                            name="plus"
                            color="yellow"
                            onClick={() => {
                              handlers.addSearchWord(
                                formProps,
                                'userName',
                                'userNames'
                              );
                            }}
                          />
                        </div>
                        {formProps.values.userNames.length ? (
                          <div className="w__search-words">
                            <Form.SearchArea
                              searchWords={formProps.values.userNames}
                              name="userNames"
                              formProps={formProps}
                            />
                          </div>
                        ) : (
                          <div className="w__search-words" />
                        )}
                      </div>

                      <div className="w__checkbox-field">
                        <Form.Label text="怪我" />
                        <div className="w__checkboxes">
                          <Field
                            component={Form.Checkbox}
                            name="isSafe"
                            label="無事"
                          />
                          <div className="w__checkbox-row">
                            <Field
                              component={Form.Checkbox}
                              name="isMinorInjury"
                              label="軽傷"
                            />
                            <Field
                              component={Form.Checkbox}
                              name="isSeriousInjury"
                              label="重傷"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="w__checkbox-field">
                        <Form.Label text="回答状況" />
                        <div className="w__checkboxes">
                          <div className="w__checkbox-row none">
                            <Field
                              component={Form.Checkbox}
                              name="unAnswered"
                              label="未回答"
                            />
                            <Field
                              component={Form.Checkbox}
                              name="answered"
                              label="回答済み"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w__row lower">
                      <div className="w__checkbox-field">
                        <Form.Label text="メール送信状況" />
                        <div className="w__checkboxes">
                          <div className="w__checkbox-row none">
                            <Field
                              component={Form.Checkbox}
                              name="isSuccess"
                              label="送信完了"
                            />
                            <Field
                              component={Form.Checkbox}
                              name="isFailed"
                              label="送信失敗"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="w__input-search">
                        <Form.Label text="所属組織" />
                        <div className="w__input">
                          <Field
                            component={Form.Input}
                            name="organization"
                            placeholder="所属組織"
                            color="white"
                          />
                          <Button.Icon
                            name="plus"
                            color="yellow"
                            onClick={() => {
                              handlers.addSearchWord(
                                formProps,
                                'organization',
                                'organizations'
                              );
                            }}
                          />
                        </div>
                        {formProps.values.organizations.length ? (
                          <div className="w__search-words">
                            <Form.SearchArea
                              searchWords={formProps.values.organizations}
                              name="organizations"
                              formProps={formProps}
                            />
                          </div>
                        ) : null}
                      </div>

                      <div className="w__input-search">
                        <Form.Label text="役職" />
                        <div className="w__input">
                          <Field
                            component={Form.Input}
                            name="position"
                            placeholder="役職"
                            color="white"
                          />
                          <Button.Icon
                            name="plus"
                            color="yellow"
                            onClick={() => {
                              handlers.addSearchWord(
                                formProps,
                                'position',
                                'positions'
                              );
                            }}
                          />
                        </div>
                        {formProps.values.positions.length ? (
                          <div className="w__search-words">
                            <Form.SearchArea
                              searchWords={formProps.values.positions}
                              name="positions"
                              formProps={formProps}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="w__search-button">
                      <Button.Normal
                        rounded
                        color="yellow"
                        text="検索する"
                        onClick={() => {
                          handlers.search(
                            formProps.values,
                            formProps,
                            props,
                            setLoading
                          );
                        }}
                        disabled={formProps.isSubmitting || loading}
                        loading={formProps.isSubmitting}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          }}
        </Formik>
        <div className="b__link">
          <div className="b__count">
            合計&nbsp;
            <span className="count">
              {Number(
                props.notifications.detail.pagination.totalCount
              ).toLocaleString()}
            </span>
            &nbsp;件
          </div>
          <div
            className="w__resend-button
          "
          >
            <Button.Normal
              color="green"
              rounded
              onClick={() => setIsResend(true)}
              disabled={props.notifications.detail.sentServerErrorCount === 0}
            >
              <Icon name="redo alternate" className="b__icon" />
              <span className="inner-text">送信失敗のユーザーに再送信する</span>
            </Button.Normal>

            <Button.Normal
              className="link-button"
              color="green"
              rounded
              onClick={() => setIsModal(true)}
              disabled={props.notifications.detail.noReplyCount === 0}
            >
              <Icon name="paper plane" className="b__icon" />
              <span className="inner-text">未回答のユーザーに再送信する</span>
            </Button.Normal>
          </div>
        </div>
        <div className="b__table">
          <Table.Main
            columns={makeColumns(props, setIsPaging, setLoading)}
            data={props.notifications.detail.pagination.data.active}
            loading={loading}
            emptyMessage="回答情報がありません"
          />
          <Pagination
            totalCount={props.notifications.detail.pagination.totalCount}
            current={props.notifications.detail.pagination.current}
            updateCurrent={(current: number) => {
              handlers.updateCurrent(props, current, setIsPaging);
            }}
            disabled={isPaging || loading}
          />
        </div>
      </div>
      <Modal.Resend
        notification={props.notifications.detail}
        setIsFailedSendModal={setIsFailedSendModal}
        me={props.me}
        isModal={isModal}
        title="未回答のユーザーに再送信"
        handleCloseModal={setIsModal}
        disabled={props.notifications.detail.noReplyCount === 0}
        match={props.match}
        message={
          <>
            <div>
              安否確認に未回答のユーザー&nbsp; (
              <b>{props.notifications.detail.noReplyCount}人</b>)&nbsp;
              に安否確認を再送信します。
            </div>
            <div>通知手段を確認してから再送信を行なってください。</div>
          </>
        }
      />
      <Modal.Resend
        notification={props.notifications.detail}
        isModal={isResend}
        setIsFailedSendModal={setIsFailedSendModal}
        handleCloseModal={setIsResend}
        title="送信失敗ユーザーに再送信"
        me={props.me}
        disabled={props.notifications.detail.sentServerErrorCount === 0}
        isFailed
        match={props.match}
        message={
          <>
            <div>
              送信失敗でユーザーへの送信が失敗したユーザー&nbsp;(
              <b>{props.notifications.detail.sentServerErrorCount}人</b>) &nbsp;
              に安否確認を再送信します。
            </div>
            <div>通知手段を確認してから再送信を行なってください。</div>
          </>
        }
      />
      <Modal.Normal
        hideCloseIcon
        hiddenCancelButton
        isAutoClose={false}
        isModal={isNotFoundModal}
        handleCloseModal={setIsNotFoundModal}
        size="xs"
        title="災害通知が存在しません"
        cancelText="前のページに戻る"
        message="存在しない災害通知です。
            ボタンをクリックして、前のページに戻ってください。"
      >
        <Button.Normal
          text="前のページに戻る"
          onClick={() => props.history.goBack()}
          color="yellow"
          className="b__go-back"
        />
      </Modal.Normal>
      <Modal.FailedCalling
        isModal={isFailedSendModal}
        handleCloseModal={setIsFailedSendModal}
      />
    </div>
  );
};

export default Detail;
